const BUTTON_SELECTOR = "[data-behaviour='sf-quick-add-adjustment']"

export default (): Array<() => void> => {
  function handleClick(e: Event): void {
    if (!(e.target instanceof HTMLElement)) {
      return
    }

    const target = e.target.closest(BUTTON_SELECTOR)

    if (!target) {
      return
    }

    e.preventDefault()
    e.stopPropagation()

    const accountEntryId = target.getAttribute('data-account-entry-id')

    window.modalCitizen.openModalPortal('adjustments-modal', {
      accountEntryId: accountEntryId ? parseInt(accountEntryId, 10) : undefined,
      mode: 'new',
    })
  }

  // The row's native title would otherwise show its own tooltip alongside
  // the button's "Create adjustment" one; swap it out while hovering the button.
  // The containment check must be against the button, not the row: the button
  // only becomes visible on row-hover, so the mouse is always already inside
  // the row when it moves onto the button, and relatedTarget would otherwise
  // always be "contained" by the row, causing this to always no-op.
  function handleHover(e: MouseEvent): void {
    if (!(e.target instanceof HTMLElement)) {
      return
    }

    const target = e.target.closest(BUTTON_SELECTOR)
    const relatedIsContained =
      e.relatedTarget instanceof Node && target?.contains(e.relatedTarget)

    if (!target || relatedIsContained) {
      return
    }

    const row = target.closest('li')

    if (!row) {
      return
    }

    const entering = e.type === 'mouseover'

    if (entering) {
      row.dataset.rowTitle = row.title
    }

    row.title = entering ? '' : row.dataset.rowTitle || ''
  }

  document.addEventListener('click', handleClick)
  document.addEventListener('mouseover', handleHover)
  document.addEventListener('mouseout', handleHover)

  return [
    (): void => document.removeEventListener('click', handleClick),
    (): void => document.removeEventListener('mouseover', handleHover),
    (): void => document.removeEventListener('mouseout', handleHover),
  ]
}
